import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { fetchUserAccess, hasRouteAccess, getSessionAccess } from '../services/roleAccessService';

const ProtectedRoute = ({ path, children }) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const location = useLocation();

  useEffect(() => {
    fetchUserAccess().then(() => {
      let access = hasRouteAccess(path);
      
      // Allow access to create-new when navigating in edit/draft mode
      if (!access && path === 'create-new') {
        const state = location.state;
        if (state && (state.mode === 'edit' || state.eightDInfoId || state.isDrafted)) {
          access = true;
        }
      }
      
      setHasAccess(access);
      setLoading(false);
    });
  }, [path, location.state]);

  if (loading) return null;
  if (!hasAccess) return <Navigate to="/dashboard" replace />;
  return children;
};

export default ProtectedRoute;
